import { Locale } from '@cibli/shared';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getLocaleWakeWordByCode } from '@/services/locale';

export const useLocaleWakeWord = () => {
  const { i18n, t } = useTranslation();
  const [wakeWord, setWakeWord] = useState<Locale | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLocaleWakeWord = useCallback(async () => {
    if (!i18n.language) {
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const data = await getLocaleWakeWordByCode(i18n.language);
      setWakeWord(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('errors.locale_fetch_failed'));
    } finally {
      setLoading(false);
    }
  }, [i18n.language, t]);

  useEffect(() => {
    fetchLocaleWakeWord();
  }, [fetchLocaleWakeWord]);

  return { data: wakeWord, isLoading: loading, error };
};
